<h3
    class="title-miles-section"
    tabindex=0
    [attr.aria-label]="'review.paymentExtrasMiles.text.sectionToUseMiles' | ibeadmin | async"
>
    <app-svg aria-hidden="true" [alt]="'Long arrow'" [svg]="'icons.svg#general--arrow--long_right'"></app-svg>
    
    <span skeletonLoader [translationKey]="'review.paymentExtrasMiles.text.payYourExtras'">
        {{ 'review.paymentExtrasMiles.text.payYourExtras' | ibeadmin | async }}
    </span>
</h3>

<ng-container *ngIf="hasError">
    <div class="container">
        <app-notification [style]="'alert'" [icon]="'icons.svg#airport--delays'" [title]="'tripExtras.title.internalError' | ibeadmin | async">
            <div message>
                <span skeletonLoader [translationKey]="'tripExtras.errorMessage.internalErrorOccured'">
                    {{ 'tripExtras.errorMessage.internalErrorOccured' | ibeadmin | async }}
                </span>
            </div>
        </app-notification>
    </div>
</ng-container>

<span *ngIf="ancillaries.length === 0" tabindex=0 skeletonLoader [translationKey]="'review.paymentExtrasMiles.text.youCanUseMiles'">
    {{ 'review.paymentExtrasMiles.text.youCanUseMiles' | ibeadmin | async }}
</span>

<div class="grid" *ngIf="ancillaries.length > 0">
    <article class="ancillary-miles-block col-4 col-tp-6 col-p-12" tabindex=0 [attr.aria-label]="INDRA_ariaLabel(ancillary)" *ngFor="let ancillary of ancillaries" (click)="INDRA_hasMilesToPay(ancillary) ? INDRA_addAncillary(ancillary) : null" [ngClass]="{'not-available': !INDRA_hasMilesToPay(ancillary) && !INDRA_isAncillarySelected(ancillary) || !user || (!hasEnoughMilesFlag && bookAwardFlights), 'is-selected': INDRA_isAncillarySelected(ancillary)}"
        [tooltip]="user && INDRA_hasMilesToPay(ancillary) || INDRA_isAncillarySelected(ancillary) ? null : INDRA_printTooltip(ancillary)">
        <div aria-hidden="true" class="ancillary-miles-block__image" [style.background-image]="INDRA_printImage(ancillary)">
            <app-svg aria-hidden="true" *ngIf="INDRA_isAncillarySelected(ancillary)" [svg]="'icons.svg#general--check_big'"></app-svg>
        </div>

        <div class="ancillary-miles-block__text" aria-hidden="true">
            <div class="ancillary-miles-block__price">{{INDRA_printCost(ancillary)}} <span class="ancillary-miles-block__price--cash">{{INDRA_printDiscount(ancillary)}}</span></div>
            <div class="ancillary-miles-block__label">{{INDRA_printCount(ancillary)}} {{INDRA_printTitle(ancillary)}}</div>
        </div>
    </article>
</div>